import { z } from 'zod';
/**
 * The public API's error vocabulary (KIR-3602 design decision D8).
 *
 * A closed set on purpose. Internal handlers can name errors however they like;
 * a customer writing a SIEM connector needs a small, stable list they can branch
 * on, and one that never grows a new member inside a version. Adding a case here
 * is a breaking change for anyone who wrote an exhaustive switch.
 */
export var V1ErrorCode;
(function (V1ErrorCode) {
    V1ErrorCode["Unauthorized"] = "Unauthorized";
    V1ErrorCode["Forbidden"] = "Forbidden";
    V1ErrorCode["NotFound"] = "NotFound";
    V1ErrorCode["RateLimited"] = "RateLimited";
    V1ErrorCode["ValidationError"] = "ValidationError";
    V1ErrorCode["Internal"] = "Internal";
})(V1ErrorCode || (V1ErrorCode = {}));
/**
 * Every non-2xx `/api/v1` response body.
 *
 * `requestId` is the trace id Cloud Trace and every log line for the request
 * carry, so a customer can quote it in a support ticket and we can find the
 * exact request. It is the reason this envelope differs from the internal
 * `errorResponseSchema` rather than reusing it.
 */
export const v1ErrorResponseSchema = z
    .object({
    error: z
        .nativeEnum(V1ErrorCode)
        .describe('Machine-readable error code from a closed set. Branch on this, never on `message`.'),
    message: z
        .string()
        .describe('Human-readable explanation. On 4xx it is written for you and names what to change; on 5xx it is a fixed generic string, because the underlying error can name internal details.'),
    requestId: z
        .string()
        .describe('Trace id for this request, also carried by every log line it produced. Quote it to Knostic support to have the exact request looked up.'),
})
    .meta({
    id: 'V1Error',
    title: 'Error',
    description: 'The body of every non-2xx response from this API. Adding a new `error` code is a breaking change, so an exhaustive switch stays exhaustive for the life of v1.',
    examples: [
        {
            error: 'Forbidden',
            message: 'This API key is not scoped to the requested organization',
            requestId: '7b3f1c2e9a4d5f60',
        },
    ],
});
//# sourceMappingURL=errors.js.map